<template>
  <v-card class="dt-modal">
    <div class="dt-modal--header">{{ $t('public_comments') }}</div>
    <div class="dt-modal--body">
      <div class="form-group">
        <TextField
          :id="'promoter_public_comments'"
          textarea
          v-bind="textFieldConfig"
          v-model="newComment"
          isModel
        />
      </div>
      <v-layout row wrap>
        <v-flex md6>
          <v-layout row wrap justify-start></v-layout>
        </v-flex>
        <v-flex md6>
          <v-layout row wrap justify-end>
            <button class="dt-button v1 s1" @click.stop="onAddComment">{{$t('submit')}}</button>
            <button class="dt-button s1" @click.stop="onCancel">{{$t('cancel')}}</button>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import TextField from "@plugins/text-field/text-field";

export default {
  components: {
    TextField
  },
  props: {},
  data: function() {
    return {
      newComment: "",

      textFieldConfig: {
        height: 142,
        showEditIconOnHover: false,
        box: true
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    onCancel: function() {
      this.$emit("cancelled");
    },
    onAddComment: function() {
      this.$emit("added", this.newComment);
      this.newComment = "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
